import { format } from 'date-fns';

import { FILTERS_ATTRIBUTES, FiltersGroups, FilterValueType } from 'constants/filters';

const getModifiedFilterValue = (value: string, valueType?: FilterValueType) => {
  switch (valueType) {
    case FilterValueType.Number:
      return value;
    case FilterValueType.Date:
      return `"${format(new Date(Number(value)), 'yyyy-MM-dd')}"`;
    default:
      return `"${value}"`;
  }
};

export const getModifiedRequestFilters = (
  filtersGroup: FiltersGroups,
  filters?: Record<string, string | string[] | undefined>,
) => {
  const appliedFilters: string[] = [];

  for (const key in filters) {
    const filterAttributes = FILTERS_ATTRIBUTES[filtersGroup][key];

    if (!filterAttributes) {
      continue;
    }

    const { apiParam, valueType } = filterAttributes;
    const values = (Array.isArray(filters[key]) ? filters[key] : [filters[key]]) as string[];

    values.forEach((value) => {
      if (apiParam === 'expired') {
        const isExpired = value === 'expired';

        return appliedFilters.push(`${apiParam}:${isExpired}`);
      }

      appliedFilters.push(`${apiParam}:${getModifiedFilterValue(value, valueType)}`);
    });
  }

  return appliedFilters;
};
